import { supabase } from "@/integrations/supabase/client";

/**
 * Wishlist (favoritos) — exige usuário autenticado.
 * Persistido em public.wishlists com RLS (cada usuário vê só os próprios).
 */
export interface WishlistRow {
  id: string;
  user_id: string;
  product_id: string;
  created_at: string;
}

export const wishlistService = {
  async listIds(userId: string): Promise<string[]> {
    const { data, error } = await supabase
      .from("wishlists")
      .select("product_id")
      .eq("user_id", userId);
    if (error) throw error;
    return (data ?? []).map((r) => r.product_id as string);
  },

  async listWithProducts(userId: string) {
    const { data, error } = await supabase
      .from("wishlists")
      .select(
        "id, product_id, created_at, product:products(*, images:product_images(id,image_url,is_primary,sort_order), category_ref:categories!products_category_id_fkey(id,name,slug))"
      )
      .eq("user_id", userId)
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data ?? [];
  },

  async add(userId: string, productId: string) {
    const { error } = await supabase
      .from("wishlists")
      .insert({ user_id: userId, product_id: productId });
    if (error && !String(error.message).includes("duplicate")) throw error;
  },

  async remove(userId: string, productId: string) {
    const { error } = await supabase
      .from("wishlists")
      .delete()
      .eq("user_id", userId)
      .eq("product_id", productId);
    if (error) throw error;
  },
};